import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import StockMovementDetailDialog from "../../pages/Stock/components/StockMovementDetailDialog";
import { fetchStockMovementDetail } from "../../services/stockService";
import { stockPostingErrorMessage } from "../../utils/stockPostingPresentation";
export default function StockMovementAuditLoader({ movementId, onClose }) {
  const { t } = useTranslation(["stock", "common"]);
  const sequence = useRef(0);
  const [state, setState] = useState({ id: null, row: null, error: "" });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const seq = ++sequence.current;
    if (!movementId) return undefined;
    const abort = new AbortController();
    setState({ id: movementId, row: null, error: "" });
    fetchStockMovementDetail(movementId, { signal: abort.signal }).then(row => {
      if (seq === sequence.current && !abort.signal.aborted) setState({ id: movementId, row, error: "" });
    }).catch(error => { if (seq === sequence.current && !abort.signal.aborted) setState({ id: movementId, row: null, error: stockPostingErrorMessage(error, t) }); });
    return () => { abort.abort(); sequence.current += 1; };
  }, [movementId, retry, t]);
  if (!movementId) return null;
  if (state.row && String(state.id) === String(movementId)) return <StockMovementDetailDialog movement={state.row} open onClose={onClose} />;
  return <div className="stock-context-feedback" role="status">{state.error || t("common:common.loading")}
    {state.error && <button type="button" onClick={() => setRetry(v => v + 1)}>{t("common:actions.refresh")}</button>}
    <button type="button" onClick={onClose}>{t("common:actions.close")}</button></div>;
}
